import axios from "axios";
import { toast } from "react-toastify";
export const GetAllDealSoldReceipt = (data) => {
  return {
    type: "get_allgetdealsoldreceipt",
    payload: data,
    loader: false,
  };
};
export function getallDealSoldreceipt() {
  return (dispatch) => {
    let pgurl = `${
      process.env.REACT_APP_API_URL
    }Vouchers/DealSold/Receipt/Populate?ProjectId=${localStorage.getItem(
      "ProjectId"
    )}`;
    if (localStorage.getItem("ProjectId") === null) {
      pgurl = `${process.env.REACT_APP_API_URL}Vouchers/DealSold/Receipt/Populate`;
    }
    axios({
      url: pgurl,
      method: "Get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllDealSoldReceipt(result.data.Data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
export const GetAllDSRTableData = (data) => {
  return {
    type: "get_allDSRtabledata",
    payload: data,
    loader: false,
  };
};
export function getallDSRpopulatetable(data) {
  return (dispatch) => {
    let pgurl = `${
      process.env.REACT_APP_API_URL
    }Vouchers/DealSold/Receipt/Get?projectid=${localStorage.getItem(
      "ProjectId"
    )}`;
    if (localStorage.getItem("ProjectId") === null) {
      pgurl = `${process.env.REACT_APP_API_URL}Vouchers/DealSold/Receipt/Get`;
    }
    axios({
      url: pgurl,
      method: "Post",
      data: JSON.stringify(data),
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllDSRTableData(result.data.Data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
